import { render, staticRenderFns } from "./TaskCreateDialog.vue?vue&type=template&id=ef152ffa&scoped=true&"
import script from "./TaskCreateDialog.vue?vue&type=script&lang=js&"
export * from "./TaskCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskCreateDialog.vue?vue&type=style&index=0&id=ef152ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef152ffa",
  null
  
)

export default component.exports